import React, { useEffect, useRef, useState } from "react";
import EventInfo from "./components/eventInfo.jsx";
import SignUp from "./components/signup.jsx";
import Timer from "./components/timer.jsx";
import Transition from "./components/transition.jsx";

function App() {
	return (
		<>
			<div className="top-section">
				<Timer></Timer>
				<Transition></Transition>
			</div>

			<div className="middle-section">
				<SignUp></SignUp>
			</div>

			<div className="bottom-section">
				<EventInfo></EventInfo>
			</div>
		</>
	);
}

export default App;
